import { PaginationType } from "../../Types/APITypes";
import { 
  Newsletter, 
  Subscriber, 
  NewsletterResponse, 
  SubscriberResponse,
  CreateNewsletterData,
  UpdateNewsletterData,
  UpdateSubscriberData
} from '../../Types/newsletter';
import API from "./API";

class NewsletterAPI extends API {
  // Newsletter endpoints
  static get_newsletters = (pagination?: PaginationType) => {
    return this.getRequest(
      `manage/newsletters?page=${pagination?.current_page || 1}&per_page=${
        pagination?.per_page || 10
      }${pagination?.search_word ? `&query=${pagination.search_word}` : ""}`,
      true
    );
  };

  static get_newsletter = (id: number) => {
    return this.getRequest(`manage/newsletters/${id}`, true);
  };

  static create_newsletter = (data: CreateNewsletterData) => {
    return this.postRequest("manage/newsletters", data, true);
  };

  static update_newsletter = (id: number, data: UpdateNewsletterData) => {
    return this.putRequest(`manage/newsletters/${id}`, data, true);
  };

  static delete_newsletter = (id: number) => {
    return this.deleteRequest(`manage/newsletters/${id}`, {}, true);
  };

  static send_newsletter = (id: number) => {
    return this.postRequest(`manage/newsletters/${id}/send`, {}, true);
  };

  // Subscriber endpoints
  static get_subscribers = (pagination?: PaginationType) => {
    return this.getRequest(
      `manage/subscribers?page=${pagination?.current_page || 1}&per_page=${
        pagination?.per_page || 10
      }${pagination?.search_word ? `&query=${pagination.search_word}` : ""}`,
      true
    );
  };

  static get_subscriber = (id: number) => {
    return this.getRequest(`manage/subscribers/${id}`, true);
  };

  static update_subscriber = (id: number, data: UpdateSubscriberData) => {
    return this.putRequest(`manage/subscribers/${id}`, data, true);
  };

  static delete_subscriber = (id: number) => {
    return this.deleteRequest(`manage/subscribers/${id}`, {}, true);
  };

  static unsubscribe_subscriber = (id: number) => {
    return this.postRequest(`manage/subscribers/${id}/unsubscribe`, {}, true);
  };
}

export default NewsletterAPI; 